module.exports = __webpack_public_path__ + "static/img/autodesk_techx_logo.1af395b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/autodesk_techx_logo.png
// module id = 0ddM
// module chunks = 1